/**
 * Theme Palette.
 */
const palette = {
    background: {
        default: '#F8FAFB',
        paper: '#FFFFFF',
    },
    common: {
        white: '#FFFFFF',
        green: '#10DE1D',
        yellow: '#FFD42B',
        red: '#F93C37',
        purple: '#8D1DAB',
        blue: '#1F62FF',
        lightBlue: '#d7eeff',
    },
    divider: '#E7ECEF',
    primary: {
        main: '#F27941',
        dark: '#D96D3B',
        contrastText: '#FFFFFF',
    },
    secondary: {
        main: '#1B998B',
        light: '#a8d6d0',
        dark: '#178073',
        contrastText: '#FFFFFF',
    },
    text: {
        primary: '#576573',
        secondary: '#98A9BC',
    },
};
export default palette;
//# sourceMappingURL=palette.js.map